export const instructionTypeForFilter = {
  filterId: 'array',
  filterMonitoringObjectName: 'string',
  filterName: 'string',
};
